import { Contact, ContactType } from './contact';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Resource } from '@patterns/core';

@Resource('acceptance_templates')
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export class AcceptanceTemplate extends Contact {
  constructor(data: any = {}) {
    super(data);
    this.type = ContactType.ACCEPTANCE_TEMPLATE;
  }
}
